module.exports = __webpack_public_path__ + "static/img/win11_1.02798a2.png";